export const interpretUserNameError = (error) => {
    if (error === "Field must contain only english letters") {
        return "errors.username.only_english_letters";
    }
    if (error === "min: 2") {
        return "errors.username.min_2";
    }
    if (error === "max: 100") {
        return "errors.username.max_100";
    }

    return null;
}

export const interpretEmailError = (error) => {
    if(error === "Field must contain email address") {
        return "errors.email.invalid_format";
    }
}

export const interpretCompanyNameError = (error) => {
    if (error === "this field is required") {
        return "errors.company_name.required";
    }
    if (error === "Field must contain only english letters") {
        return "errors.company_name.only_english_letters";
    }
    if (error === "min: 2") {
        return "errors.company_name.min_2";
    }
    if (error === "max: 250") {
        return "errors.company_name.max_250";
    }
    if(error === "Field must contain only english letters")
    {
        return "errors.company_name.only_english_letters"
    }

    return null;
}

export const interpretReceiverAddressError = (error) => {
    if (error === "this field is required") {
        return "errors.receiver_address.required";
    }
    if (error === "min: 2") {
        return "errors.receiver_address.min_2";
    }
    if (error === "max: 250") {
        return "errors.receiver_address.max_250";
    }
    if(error === "Field must contain only english letters") {
        return "errors.receiver_address.only_english_letters"
    }
    return null;
}